<template>
  <div>
      <div v-if="loading">
        <loader></loader>
      </div>
      <div class="form">
        <div class="alert alert-danger" v-if="errorMessage">
          {{errorMessage}}
        </div>
        <div class="alert alert-success" v-if="successMessage">
          {{successMessage}}
        </div>
        <fieldset v-if="!choosePassword">
          <legend>Recuperar Senha</legend>
          <div class="alert alert-info">
            Para recuperar a senha, precisamos do seu email. Será enviado um link para que você possa trocá-la.
          </div>
          <div class="form-group">
            <label for="name" class="sr-only">Email</label>
            <input id="name" class="form-control" type="email" v-model="user.email" placeholder="Email">
          </div>
          <button class="btn btn-primary" @click="askReset">Recuperar</button>
          <button class="btn btn-default" @click="$router.go(-1)">Voltar</button>
        </fieldset>
        <fieldset v-if="choosePassword">
          <legend>Escolher Senha</legend>
          <div class="alert alert-info">
            Escolha uma nova senha para sua conta
          </div>
          <form  class="form-group" :action="passwordChangeURL" method="POST">
          <div class="form-group">
            <label for="new_password" class="sr-only">Nova Senha</label>
            <input id="new_password" name="new_password" class="form-control" type="password" v-model="user.password" placeholder="Nova Senha">
          </div>
          <div class="form-group">
            <input id="token" name="token" class="sr-only" v-model="token">
            <input id="username" name="username" class="sr-only" type="password" v-model="user.username">
          </div>
          <button class="btn btn-primary">Confirmar</button>
          </form>
        </fieldset>
      </div>
  </div>
</template>

<script>

import { Parse, properties } from '../Global'
import Loader from './util/Loader'

export default {
  components: {
    Loader
  },
  data () {
    return {
      user: {
        email: '',
        username: '',
        new_password: ''
      },
      errorMessage: '',
      successMessage: '',
      choosePassword: false,
      passwordChangeURL: properties.passwordChangeURL,
      token: '',
      loading: false
    }
  },
  mounted () {
    this.loading = false
    this.choosePassword = false
    this.token = this.$route.query.token
    if (this.token) {
      this.choosePassword = true
      this.user.username = this.$route.query.username
    }
  },
  methods: {
    askReset () {
      let self = this
      self.loading = true
      Parse.User.requestPasswordReset(self.user.email).then(() => {
        self.successMessage = 'Link para recuperação de senha foi enviado ao seu email.'
        self.user.email = ''
      }, () => {
        self.errorMessage = 'Ocorreu um erro na requisição. Por favor, conferir seu email.'
      }).then(() => {
        self.loading = false
      })
    }
  }
}
</script>

<style scoped>
.form {
  max-width: 500px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// PasswordReset.vue?bae414a8